import { render, staticRenderFns } from "./RegularBuyBoxNew.vue?vue&type=template&id=c414b052&scoped=true"
import script from "./RegularBuyBoxNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegularBuyBoxNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RegularBuyBoxNew.vue?vue&type=style&index=0&id=c414b052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c414b052",
  null
  
)

export default component.exports